(function () {
  var MAX = 14, open = false;
  function lg(fs) { var l = fs.querySelector('legend'); return l ? l.textContent.trim().toLowerCase() : ''; }
  function labels(fs) { return [].slice.call(fs.querySelectorAll('label.variant-option__button-label')); }
  function taglines() {
    document.querySelectorAll('product-card .text-block p, .product-details h1, a.cart-items__title').forEach(function (el) {
      if (el.querySelector('.bm-tagline')) return;
      if (el.children.length) return;
      var t = el.textContent, i = t.indexOf(' — ');
      if (i < 1) return;
      el.textContent = t.slice(0, i);
      var s = document.createElement('span');
      s.className = 'bm-tagline';
      s.textContent = t.slice(i + 3);
      el.appendChild(document.createTextNode(' '));
      el.appendChild(s);
    });
  }
  function run() {
    document.querySelectorAll('variant-picker fieldset').forEach(function (fs) {
      var t = lg(fs);
      if (t.indexOf('color') === 0) {
        fs.classList.add('bm10-col');
        var ls = labels(fs);
        if (ls.length > MAX + 2 && !fs.querySelector('.bm10-morebtn') && !fs.classList.contains('bm10-open')) {
          fs.classList.add('bm10-collapsed');
          ls.forEach(function (l, i) { l.classList.toggle('bm10-more', i >= MAX); });
          var c = fs.querySelector('input:checked');
          if (c && ls.indexOf(c.closest('label')) >= MAX) open = true;
          if (open) { fs.classList.add('bm10-open'); }
          else {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'bm10-morebtn';
            b.textContent = '+ Ver los ' + ls.length + ' colores';
            b.addEventListener('click', function () { open = true; fs.classList.add('bm10-open'); b.remove(); });
            ls[MAX - 1].after(b);
          }
        }
      } else if (t.indexOf('talla') === 0) {
        fs.classList.add('bm10-size');
        if (!fs.querySelector('.bm10-kids')) {
          var all = labels(fs);
          var k = all.filter(function (l) { var i = l.querySelector('input'); return i && /^\d{1,2}\/\d{1,2}$/.test(i.value); });
          if (k.length && k.length < all.length) {
            var s = document.createElement('span');
            s.className = 'bm10-kids'; s.textContent = 'Tallas infantiles';
            k[0].before(s);
          }
        }
      }
    });
    document.querySelectorAll('.bm-chipq').forEach(function (b) {
      if (/Cuándo me llega|ponerle mi logo/.test(b.textContent)) b.style.display = 'none';
    });
    taglines();
  }
  var tmr; function sched() { clearTimeout(tmr); tmr = setTimeout(run, 80); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  try {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var n = ms[i].target;
        if (n.nodeType === 1 && (n.closest('variant-picker,[data-bm-ask],product-card,.product-grid,cart-items-component,cart-drawer-component,.resource-list') || (n.querySelector && n.querySelector('variant-picker,product-card,cart-items-component')))) { sched(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
